export default {
  title: "Bedrijfsgegevens",

  name: {
    title: "Bedrijfsnaam",
    input: {
      companyName: "Bedrijfsnaam"
    },
    button: {
      save: "Opslaan"
    },
    api: {
      name: {
        patched: "Bedrijfsnaam opgeslagen",
      },
    },
  },

  address: {
    title: "Adres",
    input: {
      street: "Straat",
      streetNumber: "Huisnummer",
      streetNumberAddition: "Toevoeging",
      postalCode: "Postcode",
      country: "Land",
      city: {
        label: "Stad",
        required: {
          country: "Selecteer eerst een land"
        },
      },
    },
    button: {
      save: "Opslaan"
    },
    api: {
      patch: {
        success: "Adres opgeslagen",
      },
    },
  },

  email: {
    title: "E-mailadres",
    input: {
      email: "E-mailadres"
    },
    button: {
      save: "Opslaan",
    },
    api: {
      email: {
        patched: "E-mail adres opgeslagen",
      },
    },
  },

  bankAccount: {
    title: "Bankrekening",
    input: {
      bank: "Bank",
      iban: "IBAN",
      swift: "SWIFT",
      holder: "Houder",
    },
    button: {
      save: "Opslaan",
    },
    api: {
      patched: "Bankrekening opgeslagen"
    }
  },

  api: {
    name: {
      notNull: "Geef een bedrijfsnaam op",
    },
  },
}
